import { render, staticRenderFns } from "./ApiScopes.vue?vue&type=template&id=1e94ef50&"
import script from "./ApiScopes.vue?vue&type=script&lang=js&"
export * from "./ApiScopes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports